import { ProjectMember } from "domain/entities/project-member";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface CurrentProjectMemberState {
  currentProjectMember: ProjectMember | null;
  setCurrentProjectMember: (newCurrentProjectMember: Partial<ProjectMember> | undefined) => void;
  resetcurrentProjectMember: () => void;
}

const initialCurrentProjectMemberState: ProjectMember = {
  id: "",
  startAt: undefined,
  endAt: undefined,
  employee: { id: "", name: "" },
  project: { id: "", name: "" },
  projectRole: undefined,
  status: undefined,
  createdAt: new Date(),
  modifiedAt: new Date(),
};

export const useCurrentProjectMemberStore = create<CurrentProjectMemberState>()(
  devtools(
    (set) => ({
      currentProjectMember: initialCurrentProjectMemberState,
      setCurrentProjectMember: (newCurrentProjectMember) =>
        set((state) => ({
          currentProjectMember: newCurrentProjectMember
            ? { ...state.currentProjectMember, ...newCurrentProjectMember }
            : undefined, 
        })),
      resetcurrentProjectMember: () => set({ currentProjectMember: initialCurrentProjectMemberState }),
    }),
    { name: "CurrentProjectMember" }
  )
);
